import { __assign, __rest } from "tslib";
import React from 'react';
import InternalStatusIndicator from './internal';
export default function StatusIndicator(_a) {
    var _b = _a.type, type = _b === void 0 ? 'success' : _b, rest = __rest(_a, ["type"]);
    return React.createElement(InternalStatusIndicator, __assign({ type: type }, rest));
}
